import EventProjectUsersResetByProjectRecursive from "./project-user/reset-by-project-recursive"
import SessionProjectDelta from "./project/project-delta"
import SessionEvent_CompanyDelta from "./company/delta"
import EventCompanyUsersDelete from "./company-user/delete"
import EventCompanyUsersNew_v2 from "./company-user/new_v2"
import EventCompanyUsersDelta from "./company-user/delta"
import SessionProjectUsersResetByCompany from "./project-user/reset-by-company"
import SessionProjectMove from "./project/project-move"
import SessionEventDoNothing from "./event-do-nothing"
import SessionProjectNew from "./project/project-new"
import SessionDocumentDelta from "./document/delta"
import EventPinDelete from "./pin/pin-delete"
import SessionExpenseDelta from "./expense/delta"
import SessionTaskMessageEvent from "./task-message/universal"
import SessionTimeReportEvent from "./time-report/universal"
import SessionRelationEvent from "./relation/universal"
import SessionEventReset from "./event/reset"
import SessionEventNew from "./event/new"
import SessionEventDelete from "./event/delete"
import SessionEventDelta from "./event/delta"
import SessionEventMove from "./event/move"
import SessionEventLoadOlder from "./event/load-older"
import SessionNotepadDelta from "./notepad/delta"
import SessionEvent_CompanySettingsReset from "./company/company-settings"
import SessionEvent_CompaniesReset from "./company/reset"
import SessionEvent_CompanyNew from "./company/company-new"
import SessionEvent_CompanyChange from "./company/company-change"
import SessionEventMeChange from "./me/me-change"
import SessionEvent_ChatRoomsReset from "./chat/chat-rooms-reset"
import SessionEvent_ChatRoomNew from "./chat/chat-room-new"
import SessionEvent_ChatMessageNew from "./chat/chat-message-new"
import SessionEvent_ChatMessageStar from "./chat/chat-message-star"
import SessionEvent_ChatMessageUnstar from "./chat/chat-message-unstar"
import SessionEvent_ChatMessageDelete from "./chat/chat-message-delete"
import SessionEvent_ChatMessageUpdate from "./chat/chat-message-update"
import SessionEvent_ChatRoomDelete from "./chat/chat-room-delete"
import SessionEvent_ChatRoomUpdate from "./chat/chat-room-update"
import SessionEvent_ChatMessageDelta from "./message-reaction/new-chat-message-reaction"
import SessionGoalEvent from "./goal/universal"
import SessionCommentEvent from "./comment/universal"
import SessionEventHourlyCostHistory from "./hourly-cost-history/universal"
import {EntityType} from "../gd/const/item"
import SessionEvent_OfficesReset from "./offices/offices"
import SessionEvent_TemplatesReset from "./templates/templates"
import EventProjectsSettings from "./project/projects-settings"
import EventCustomViewsResetByCompany from "./custom-view/reset-by-company"
import StarredResetEvent from "./starred/reset"
import SessionEvent_CustomEntityReset from "./custom-entity/reset"
import SessionEvent_AiAgentReset from "./ai-agent/reset"
import SessionEvent_AiAgentNew from "./ai-agent/new"
import SessionEvent_AiAgentDelta from "./ai-agent/delta"
import SessionEvent_AiAgentDelete from "./ai-agent/delete"
import SessionEvent_ResourceReset from "./resource/reset"
import SessionEvent_ResourceNew from "./resource/new"
import SessionEvent_ResourceDelta from "./resource/delta"
import SessionEvent_ResourceDelete from "./resource/delete"
import SessionEvent_ActionReset from "./action/reset"
import SessionEvent_WebhookReset from "./webhook/reset"
import SessionEvent_AutomationNotification from "./automation/notification"
import SessionEvent_OpenSystemLink from "./system-link/open-system-link"
import SessionSavedViewDelta from "./saved-view/saved-view"
import SessionEventDataImportProgress from "./data-import/universal"
import EventProjectChange from "./project/project-change"
import EventProjectDelete from "./project/project-delete"
import EventPinsReset from "./pin/pins-reset"
import SessionEvent_DepartmentReset from "./department/reset"
import SessionEvent_TeamReset from "./teams/reset"
import EventCompanyUsersReset from "./company-user/reset"
import EventCompanyUserChange from "./company-user/change"
import EventCompanyUsersNew from "./company-user/new"
import EventCompanyRoleChange from "./company-role/change"
import EventCustomFieldsResetByCompany from "./custom-field/reset-by-company"
import EventCustomFieldNew from "./custom-field/new"
import EventCustomFieldsReset from "./custom-field/reset"
import SessionEvent_TeamNew from "./teams/new"
import SessionEvent_TeamDelete from "./teams/delete"
import SessionEvent_TeamDelta from "./teams/delta"
import EventProjectUsersReset from "./project-user/reset"
import EventProjectUsersResetByProject from "./project-user/reset-by-project"
import EventProjectUsersResetByProjectRecursiveV3 from "./project-user/reset-by-project-recursive-v3"
import EventProjectsAndUsersResetV3 from "./projects-and-users/reset-v3"
import EventProjectsAndUsersReset from "./projects-and-users/reset"
import EventCompanyUsersDeletedReset from "./company-user-deleted/reset"
import SessionProjectTaskEvent from "./project-task/new"
import SessionDataStorageDelta from "./data-storage/delta"
import SessionEvent_MyWorkNew from "./my-work/new"
import SessionEvent_MyWorkDelete from "./my-work/delete"
import SessionEvent_MyWorkChange from "./my-work/change"
import SessionActionItemsStorageDelta from "./action-items-storage/delta";

// @ts-ignore
import EventProjectTemplateResetByCompany from "./project-templates/reset-by-company"
// @ts-ignore
import SessionCrmContact from "./crm/crm-contact"
// @ts-ignore
import SessionCrmAccount from "./crm/crm-account"
// @ts-ignore
import SessionTaskDelta from "./task/delta"
// @ts-ignore
import SessionTaskMove from "./task/move"
// @ts-ignore
import SessionTaskNew from "./task/add"
// @ts-ignore
import SessionExpenseCategoryReset from "./expense-category/reset"
// @ts-ignore
import SessionTaskDelete from "./task/delete"
// @ts-ignore
import SessionTaskTagNew from "./task-tag/add"
// @ts-ignore
import SessionTaskTagDelete from "./task-tag/delete"
// @ts-ignore
import SessionDependencyNew from "./dependency/add"
// @ts-ignore
import SessionDependencyDelete from "./dependency/delete"
// @ts-ignore
import SessionMyTasksNew from "./my-tasks/new"
// @ts-ignore
import EventPortfolioReset from "./portfolio/portfolio-reset"
// @ts-ignore
import EventPortfolioNew from "./portfolio/portfolio-new"
// @ts-ignore
import EventPortfolioDelta from "./portfolio/portfolio-delta"
// @ts-ignore
import EventPortfolioDelete from "./portfolio/portfolio-delete"
// @ts-ignore
import SessionEventTimerTask from "./timer/task"
// @ts-ignore
import SessionDocumentNew from "./document/add"
// @ts-ignore
import SessionDocumentDelete from "./document/delete"
// @ts-ignore
import SessionRequestFormNew from "./request-form/new"
// @ts-ignore
import SessionRequestFormDelete from "./request-form/delete"
// @ts-ignore
import SessionRequestFormDelta from "./request-form/delta"
// @ts-ignore
import EventProjectsNew from "./projects/new"

type RawEvent = {
    object      : string | string[]
    method      : string
    uid         : ID
    data        : any
    fromSID     : any
    companyId   : ID
}

const debug = {
    error: true
};

export default function SessionEventFactory(rawEvent: RawEvent): any {

    let Event: any;
    // console.log("Session eventFactory", rawEvent);

    let object: any
    if (Array.isArray(rawEvent.object)) {
        object = rawEvent.object[0]
    } else {
        object = rawEvent.object
    }

    switch (object) {
        case EntityType.SAVED_VIEW:

            return new SessionSavedViewDelta(rawEvent)

        case EntityType.CUSTOM_ENTITY:
            // reset only
            return new SessionEvent_CustomEntityReset(rawEvent);

        case EntityType.AI_AGENT:
            switch (rawEvent.method) {
                case 'reset'    : return new SessionEvent_AiAgentReset(rawEvent)
                case 'new'      : return new SessionEvent_AiAgentNew(rawEvent)
                case 'delta'    : return new SessionEvent_AiAgentDelta(rawEvent)
                case 'delete'   : return new SessionEvent_AiAgentDelete(rawEvent)
            }
            break;

        case EntityType.RESOURCE:
            switch (rawEvent.method) {
                case 'reset'    : return new SessionEvent_ResourceReset(rawEvent)
                case 'new'      : return new SessionEvent_ResourceNew(rawEvent)
                case 'delta'    : return new SessionEvent_ResourceDelta(rawEvent)
                case 'delete'   : return new SessionEvent_ResourceDelete(rawEvent)
            }
            break;

        case EntityType.ACTION:
            switch (rawEvent.method) {
                case 'reset'    : return new SessionEvent_ActionReset(rawEvent)
            }
            break

        case EntityType.WEBHOOK:
            switch (rawEvent.method) {
                case 'reset'    : return new SessionEvent_WebhookReset(rawEvent)
            }
            break

        // Every automation notification, keyed by `method` inside the event.
        // Used to arrive as the string "automation" - the one model that did
        // not send its EntityType.
        case EntityType.AUTOMATION:
            return new SessionEvent_AutomationNotification(rawEvent)

        case EntityType.OFFICE:
            switch (rawEvent.method) {
                case 'reset': {
                    return new SessionEvent_OfficesReset(rawEvent);
                }
            }
            break;

        case EntityType.TEMPLATE:
            switch (rawEvent.method) {
                case 'reset': {
                    return new SessionEvent_TemplatesReset(rawEvent);
                }
            }
            break;

        case 'system-link':
            // only opens
            return new SessionEvent_OpenSystemLink(rawEvent)

        case 'notepad':
            switch (rawEvent.method) {

                case 'delta':
                    return new SessionNotepadDelta(rawEvent)
                default:
                    console.error("Error in event parsing A0394");
                    break;
            }
            break;


        case 'me':
            switch (rawEvent.method) {

                // case 'change': Event = require('./me/me-change'); break;
                case 'change': {
                    // console.log(rawEvent);
                    return new SessionEventMeChange(rawEvent)
                }
                default:
                    console.error("Error in event parsing A0394");
                    break;

            }
            break;
        case 'assigned-tasks':

            switch (rawEvent.method) {
                case 'reset': Event = require('./assigned-tasks/reset'); break;
                case 'reset-upcoming': Event = require('./assigned-tasks/reset-upcoming'); break;
                case 'reset-planning': Event = require('./assigned-tasks/reset-planning'); break;
                // case 'new': Event = require('./assigned-tasks/new'); break;
                // case 'delete': Event = require('./assigned-tasks/delete'); break;
                // case 'change': Event = require('./assigned-tasks/change'); break;
            }

            break;

        // OLd uzalos' dlya notes + kakih to starih menu settings
        // case 'account-settings':
        //     switch (rawEvent.method) {
        //         case 'change': Event = require('./account-settings/reset'); break;
        //     }
        //     break;

        case 'expense':
            // switch (rawEvent.method) {
            //
            // }
            return new SessionExpenseDelta(rawEvent)

        case 'quick-notes':
            switch (rawEvent.method) {
                case 'reset': Event = require('./quick-notes/reset'); break;
            }
            break;

        case 'dashboard':
            switch (rawEvent.method) {
                case 'reset': Event = require('./dashboard/reset'); break;
            }
            break;

        case 'company':
            switch (rawEvent.method) {

                case 'reset':
                    return new SessionEvent_CompaniesReset(rawEvent)

                case 'delta':
                    return new SessionEvent_CompanyDelta(rawEvent)

                case 'new':
                    return new SessionEvent_CompanyNew(rawEvent)

                case 'change':
                    return new SessionEvent_CompanyChange(rawEvent)

                default: console.log("Error in event parsing A0394"); break;

            }

            break;

        case 'company-role':
            switch (rawEvent.method) {
                case 'change':
                    return new EventCompanyRoleChange(rawEvent)

                default:
                    console.log("Error in event parsing A03Y4");
                    break;
            }
            break;

        case 'user':
            switch (rawEvent.method) {
                case 'reset': Event = require('./user/reset'); break;
                case 'reset-by-company': Event = require('./user/reset'); break;
                case 'change': Event = require('./user/change'); break;
                case 'new': Event = require('./user/new'); break;
                //case 'change-personal': Event = require('./user/change-personal'); break;
                default: console.error("Error in event parsing A0394"); break;
            }
            break;

        case 'company-user':
            switch (rawEvent.method) {
                case 'change'   :
                    // Event = require('./company-user/change'); break;
                    return new EventCompanyUserChange(rawEvent)
                case 'reset'    :
                    // Event = require('core/gd-session/company-user/reset'); break;
                    return new EventCompanyUsersReset(rawEvent)

                case 'delete'   :
                    return new EventCompanyUsersDelete(rawEvent) //Event = require('./company-user/delete'); break;
                case 'new'      :
                    // Event = require('core/gd-session/company-user/new'); break;
                    return new EventCompanyUsersNew(rawEvent)
                case 'new-v2'   : return new EventCompanyUsersNew_v2(rawEvent) // nado razrulit' s companyUser.isDeleted...
                case 'delta'    : return new EventCompanyUsersDelta(rawEvent)
                //
                // case 'delta-new':       Event = EventCompanyUsersNew_v2; break;
                // case 'delta-delete':
                // case 'delta':


                default: console.error("Error in event parsing A0394"); break;
            }
            break;

        case 'company-user-deleted':
            switch (rawEvent.method) {
                case 'reset':
                    return new EventCompanyUsersDeletedReset(rawEvent)
                default:
                    console.error("#zzmdkd2 Error in event parsing"); break;
            }
            break;


        case 'company-priority':
            switch (rawEvent.method) {
                case 'reset': Event = require('./company-priority/reset'); break;
                case 'reset-by-company': Event = require('./company-priority/reset-by-company'); break;
            }
            break;
        case 'company-settings':
            switch (rawEvent.method) {
                case 'reset': return new SessionEvent_CompanySettingsReset(rawEvent)
            }
            break;
        case 'starred':
            switch (rawEvent.method) {
                case 'reset': return new StarredResetEvent(rawEvent)

                default: console.log("Error in event parsing A0294"); break;

            }
            break;
        case 'pin':
            switch (rawEvent.method) {
                case 'delete':
                    return new EventPinDelete(rawEvent)

                case 'reset':
                    return new EventPinsReset(rawEvent)

                default:
                    console.log("Error in event parsing A0294");
                    break;

            }
            break;

        case 'projects-and-users':
            switch (rawEvent.method) {
                case 'reset':
                    return new EventProjectsAndUsersReset(rawEvent)
                    // Event = require('core/gd-session/projects-and-users/reset');
                    // break;
            }
            break;

        case 'projects-and-users-v3':
            switch (rawEvent.method) {
                case 'reset':
                    return new EventProjectsAndUsersResetV3(rawEvent)
            }
            break;

        case 'timer':
            return new SessionEventTimerTask(rawEvent)

        case 'crm-contact':
            return new SessionCrmContact(rawEvent);

        case 'crm-account':
            return new SessionCrmAccount(rawEvent);

        case 'expense-category':
            switch (rawEvent.method) {
                case 'reset':
                default:
                    return new SessionExpenseCategoryReset(rawEvent);
            }

        case 'project-template':
            switch (rawEvent.method) {
                case 'reset':
                    return new EventProjectTemplateResetByCompany(rawEvent);
            }
            break;

        case 'projects':
            switch (rawEvent.method) {
                case 'new':
                    return new EventProjectsNew(rawEvent);
                default:
                    console.log("Error in event parsing #kkd983");
                    break;

            }
            break;

        case 'project':
            switch (rawEvent.method) {

                case 'delete':
                    return new EventProjectDelete(rawEvent)

                case 'change':
                    return new EventProjectChange(rawEvent)

                case 'move':
                    return new SessionProjectMove(rawEvent)

                case 'new':
                    return new SessionProjectNew(rawEvent)

                // vot etot metod kstati po idee ne uzaetsya (!) - 'projects-and-users' is used instead
                // case 'reset':
                //     return new EventProjectsReset(rawEvent)

                case 'delta':
                    return new SessionProjectDelta(rawEvent)

                default:
                    console.log("Error in event parsing A0294");
                    break;

            }
            break;
        case 'project-settings':
            switch (rawEvent.method) {

                case 'reset':
                    return new EventProjectsSettings(rawEvent);

                default:
                    console.log("Error in event parsing project-settings", rawEvent);
                    break;
            }
            break;

        case 'project-user':
            switch (rawEvent.method) {
                case 'reset':
                    return new EventProjectUsersReset(rawEvent)

                case 'reset-by-company':
                    return new SessionProjectUsersResetByCompany(rawEvent)

                case 'reset-by-project':
                    return new EventProjectUsersResetByProject(rawEvent)

                case 'reset-by-project-recursive':
                    return new EventProjectUsersResetByProjectRecursive(rawEvent)

                case 'reset-by-project-recursive-v3':
                    return new EventProjectUsersResetByProjectRecursiveV3(rawEvent)

                // default: console.log("Error in event parsing A0294"); break;
            }
            break;

        case 'portfolio':
            switch (rawEvent.method) {
                case 'reset'    : return new EventPortfolioReset(rawEvent)
                case 'new'      : return new EventPortfolioNew(rawEvent)
                case 'delta'    : return new EventPortfolioDelta(rawEvent)
                case 'delete'   : return new EventPortfolioDelete(rawEvent)
            }

        //case 'project-group':
        //    switch (rawEvent.method) {
        //
        //        case 'reset':
        //            const EventProjectGroupsReset = require('./project-groups/project-groups-reset');
        //            return new EventProjectGroupsReset(rawEvent.uid,rawEvent.data);
        //            break;
        //
        //        case 'reset-by-company':
        //            const EventProjectGroupsResetByCompany = require('./project-groups/project-groups-reset-by-company');
        //            return new EventProjectGroupsResetByCompany(rawEvent.uid,rawEvent.data);
        //            break;
        //
        //        default: console.log("Error in event parsing A0294"); break;
        //    }
        //    break;
        case 'department':
            switch (rawEvent.method) {

                case 'reset':
                    return new SessionEvent_DepartmentReset(rawEvent);

                case 'reset-by-company':
                    const EventDepartmentsResetByCompany = require('./department/department-reset-by-company');
                    return new EventDepartmentsResetByCompany(rawEvent.uid,rawEvent.data);

                default:
                    console.log("Error in event parsing A0294");
                    break;
            }
            break;

        case 'team':
            switch (rawEvent.method) {

                case 'new':
                    return new SessionEvent_TeamNew(rawEvent)

                case 'delete':
                    return new SessionEvent_TeamDelete(rawEvent)

                case 'delta':
                    return new SessionEvent_TeamDelta(rawEvent)

                case 'reset':
                    return new SessionEvent_TeamReset(rawEvent)

                default:
                    console.log("Error in event parsing team", rawEvent)
                    break;
            }
            break;

        case 'my-tasks':
            switch (rawEvent.method) {
                case 'new': return new SessionMyTasksNew(rawEvent);

                default: console.log("Error in event parsing myTasks", rawEvent); break;
            }
            break;

        case 'task':
            switch (rawEvent.method) {

                case 'reset':
                    // const EventTaskReset = require('./task/task-reset');
                    // return new EventTaskReset(rawEvent.uid, rawEvent.data, rawEvent.fromSID);
                    return new SessionEventDoNothing(rawEvent)

                // case 'reset-todo-list': Event = require('./task/task-reset-todo-list'); break;
                case 'reset-todo-list':
                    return new SessionEventDoNothing(rawEvent)

                case 'update-custom-field-value': Event = require('./task/task-update-custom-field-value'); break;

                case 'move'     : return new SessionTaskMove(rawEvent);
                case 'delta'    : return new SessionTaskDelta(rawEvent);
                case 'new'      : return new SessionTaskNew(rawEvent);
                case 'delete'   : return new SessionTaskDelete(rawEvent);

                default: console.log("Error in event parsing A02987"); break;
            }
            break;

        case EntityType.PROJECT_TASK:
            switch (rawEvent.method) {
                case 'new'      :
                case 'delete'   :
                case 'delta'    :
                    return new SessionProjectTaskEvent(rawEvent)

                default:
                    console.log('SessionEventFactory: EntityType.PROJECT_TASK method is not implemented', rawEvent.method, rawEvent)
            }
            break

        case 'task-tag':
            switch (rawEvent.method) {
                case 'new'      : return new SessionTaskTagNew(rawEvent);
                case 'delete'   : return new SessionTaskTagDelete(rawEvent);

                default: console.log("Error in event parsing 'task-tag'", rawEvent); break;
            }
            break;

        case 'task-message':
            switch (rawEvent.method) {
                case 'new'      :
                case 'delete'   :
                case 'delta'    : return new SessionTaskMessageEvent(rawEvent)

                default: console.log("Error in event parsing 'task-message'", rawEvent); break
            }
            break

        case 'dependency':
            switch (rawEvent.method) {
                case 'new'      : return new SessionDependencyNew(rawEvent);
                case 'delete'   : return new SessionDependencyDelete(rawEvent);

                default: console.log("Error in event parsing 'dependency'", rawEvent); break;
            }
            break;

        case 'document':
            switch (rawEvent.method) {
                case 'delta'    : return new SessionDocumentDelta(rawEvent)
                case 'new'      : return new SessionDocumentNew(rawEvent)
                case 'delete'   : return new SessionDocumentDelete(rawEvent)
                default         : console.log("Error in event parsing 'document'", rawEvent); break
            }
            break

        case 'my-work':
            switch (rawEvent.method) {
                case 'reset'            : Event = require('./my-work/reset'); break;
                case 'new'              : return new SessionEvent_MyWorkNew(rawEvent)
                case 'delete'           : return new SessionEvent_MyWorkDelete(rawEvent)
                case 'change-positions' : Event = require('./my-work/change-positions'); break;
                case 'change'           : return new SessionEvent_MyWorkChange(rawEvent)
            }
            break

        case 'update':
            switch (rawEvent.method) {
                // case 'reset': Event = require('./update/reset'); break; Old not updates in session anymore
                case 'new': Event = require('./update/new'); break;
            }
            break;
        case 'counter':
            switch (rawEvent.method) {
                case 'reset': Event = require('./update/counter'); break;
            }
            break;
        /*case 'project-type':
            switch (rawEvent.method) {
                case 'reset': Event = require('./project-type/reset'); break;
                case 'reset-by-company': Event = require('./project-type/reset-by-company'); break;
                case 'new': Event = require('./project-type/new'); break;
            }
            break;*/
        // a chto ento takoe ?
        case 'group-type':
            switch (rawEvent.method) {
                case 'reset': Event = require('./group-type/reset'); break;
            }
            break;
        case 'custom-view':
            switch (rawEvent.method) {
                case 'reset'    : return new EventCustomViewsResetByCompany(rawEvent)
                case 'update'   : Event = require('./custom-view/update'); break;
                case 'delete'   : Event = require('./custom-view/delete'); break;
            }
            break;
        case 'task-type':
            switch (rawEvent.method) {
                case 'reset': Event = require('./task-type/reset'); break;
                case 'reset-by-company': Event = require('./task-type/reset-by-company'); break;
                case 'new': Event = require('./task-type/new'); break;
            }
            break;
        case 'note-type':
            switch (rawEvent.method) {
                case 'reset': Event = require('./note-type/reset'); break;
                case 'reset-by-company': Event = require('./note-type/reset-by-company'); break;
                case 'new': Event = require('./note-type/new'); break;
            }
            break;
        case 'todo-list-template':
            switch (rawEvent.method) {
                case 'reset': Event = require('./todo-list-template/reset'); break;
                case 'reset-by-company': Event = require('./todo-list-template/reset-by-company'); break;
                case 'new': Event = require('./todo-list-template/new'); break;
            }
            break;
        case 'custom-field':
            switch (rawEvent.method) {
                case 'reset':
                    // Event = require('core/gd-session/custom-field/reset'); break;
                    return new EventCustomFieldsReset(rawEvent)

                case 'reset-by-company':
                    return new EventCustomFieldsResetByCompany(rawEvent)
                    // Event = require('core/gd-session/custom-field/reset-by-company'); break;

                case 'new':
                    // Event = require('core/gd-session/custom-field/new'); break;
                    return new EventCustomFieldNew(rawEvent)
            }
            break;

        case 'status':
            switch (rawEvent.method) {
                case 'reset': Event = require('./status/reset'); break;
                case 'reset-by-company': Event = require('./status/reset-by-company'); break;
                case 'new': Event = require('./status/new'); break;
            }
            break;
        // case 'favorite':
        //     switch (rawEvent.method) {
        //         case 'reset': Event = require('./favorite/reset'); break;
        //         default: console.log("Error in event parsing A0394"); break;
        //     }
        //     break;
        // case 'user-invitation':
        //     switch (rawEvent.method) {
        //         case 'reset': Event = require('./user-invitation/reset'); break;
        //         default: console.log("Error in event parsing A0394"); break;
        //     }
        //     break;
        case 'modules':
            switch (rawEvent.method) {
                case 'reset': Event = require('./modules/reset'); break;
            }
            break;
        case 'work-schedule-access':
            switch (rawEvent.method) {
                case 'reset': Event = require('./work-schedule-access/reset'); break;
            }
            break;
        case 'export-pdf':
            switch (rawEvent.method) {
                case 'result': Event = require('./export-pdf/result'); break;
            }
            break;
        case 'chat-rooms':
            switch (rawEvent.method) {
                case 'reset':           return new SessionEvent_ChatRoomsReset(rawEvent)
            }
            break;
        case 'chat-room':
            switch (rawEvent.method) {
                case 'new':             return new SessionEvent_ChatRoomNew(rawEvent);
                case 'delete':          return new SessionEvent_ChatRoomDelete(rawEvent);
                case 'update':          return new SessionEvent_ChatRoomUpdate(rawEvent);

                case 'new-message':     return new SessionEvent_ChatMessageNew(rawEvent);
                case 'message-delete':  return new SessionEvent_ChatMessageDelete(rawEvent);
                case 'message-update':  return new SessionEvent_ChatMessageUpdate(rawEvent);
                case 'message-star':    return new SessionEvent_ChatMessageStar(rawEvent);
                case 'message-unstar':  return new SessionEvent_ChatMessageUnstar(rawEvent);
            }
            break;
        case 'chat-message' :
            switch (rawEvent.method){
                case 'delta'        : return new SessionEvent_ChatMessageDelta(rawEvent)
            }
            break

        case 'event':
            switch (rawEvent.method) {
                case 'reset'        : return new SessionEventReset(rawEvent)
                case 'new'          : return new SessionEventNew(rawEvent)
                case 'delete'       : return new SessionEventDelete(rawEvent)
                case 'delta'        : return new SessionEventDelta(rawEvent)
                case 'move'         : return new SessionEventMove(rawEvent)
                // case 'update'       : Event = require('./event/update'); break;
                case 'load-older'   : return new SessionEventLoadOlder(rawEvent)
            }
            break;


        case 'meetings':
            switch (rawEvent.method) {
                case 'reset':           Event = require('../model2/meeting/session/event/reset'); break;
            }
            break;

        case 'meeting':
            switch (rawEvent.method) {
                case 'new':             Event = require('../model2/meeting/session/event/new'); break;
                case 'delete':          Event = require('../model2/meeting/session/event/delete'); break;
                case 'update':          Event = require('../model2/meeting/session/event/update'); break;
            }
            break;

        case 'note':
            switch (rawEvent.method) {
                case 'update':          Event = require('../model2/meeting/session/event/note-update'); break;
            }
            break;

        case 'reminder':
            switch (rawEvent.method) {
                case 'new':             Event = require('./reminders/event/new'); break;
                case 'delete':          Event = require('./reminders/event/delete'); break;
                case 'update':          Event = require('./reminders/event/update'); break;
                case 'reset':           Event = require('./reminders/event/reset'); break;
            }
            break;

        case 'my-work-sort':
            switch (rawEvent.method) {
                case 'change':          Event = require('./my-work/sort-positions/change-sort-positions'); break;
                case 'reset':           Event = require('./my-work/sort-positions/reset-sort-positions'); break;
            }
            break;

        case 'request-form':
            switch (rawEvent.method) {
                case 'new'      : return new SessionRequestFormNew(rawEvent)
                case 'delete'   : return new SessionRequestFormDelete(rawEvent)
                case 'delta'    : return new SessionRequestFormDelta(rawEvent)
            }
            break

        case 'time-report':
            switch (rawEvent.method) {
                case 'new'      :
                case 'delete'   :
                case 'delta'    : return new SessionTimeReportEvent(rawEvent)
            }
            break

        case 'goal':
            switch (rawEvent.method) {
                case 'new'      :
                case 'delete'   :
                case 'delta'    :
                case 'move'     : return new SessionGoalEvent(rawEvent)
            }
            break

        case 'comment':
            switch (rawEvent.method) {
                case 'new'      :
                case 'delete'   :
                case 'delta'    : return new SessionCommentEvent(rawEvent)
            }
            break

        case EntityType.RELATION:
            switch (rawEvent.method) {
                case 'new'      :
                case 'delete'   : return new SessionRelationEvent(rawEvent)

                default: console.log("Error in event parsing RELATION", rawEvent); break
            }
            break

        case EntityType.HOURLY_COST_HISTORY:
            return new SessionEventHourlyCostHistory(rawEvent)

        case EntityType.DATA_IMPORT:
            return new SessionEventDataImportProgress(rawEvent)

        case EntityType.DATA_STORAGE:
            switch (rawEvent.method) {
                case 'delta':
                    return new SessionDataStorageDelta(rawEvent)
            }
            break

        case EntityType.ACTION_ITEMS_STORAGE:
            switch (rawEvent.method) {
                case 'delta':
                    return new SessionActionItemsStorageDelta(rawEvent)
            }
            break

        default:
            if (debug.error) console.error("Unknow Event $324fdsf9");
            break;
    }

    if (!Event) {
        if (debug.error) console.error("Unknown session Event",rawEvent);
        return false;
    }

    // ignore other companies
    if (gd.companyId && rawEvent.companyId && gd.companyId!==rawEvent.companyId) {
        if (debug.error) console.warn("Session event from different company -> Ignore!",rawEvent);
        return false;
    }


    return new Event(rawEvent.uid, rawEvent.data, rawEvent.fromSID, rawEvent.companyId, rawEvent);


}
